import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Header from "./Header";
import { useGetFeedbackHeaderData } from "../../Hooks/AssesmentHooks";
import Annotations from "./Annotation";
import { IoIosArrowBack } from "react-icons/io";

const Preview = (props) => {
   const { id } = useParams();
    const navigate = useNavigate()
  // const interviewId = 5623;

  const { data: feedBackHeaderData } = useGetFeedbackHeaderData({
    params: {
      interviewId: id,
    },
    enabled: !!id,
  });

  return (
    <>
      <div className="h-[90vh] overflow-y-auto customScrollBar flex justify-center bg-[#F8F8F8]">
        <div className="aiReviewContent w-3/4">
          <div class="headerWrapper mb-4">
            <Header data={feedBackHeaderData} />
          </div>
          <div className="annotations">
            <p className="font-semibold mb-4 mt-4 flex items-center gap-1">
              <span onClick={()=> navigate(-1)} className="cursor-pointer">
                <IoIosArrowBack />
              </span>
              Annotations
            </p>
            <Annotations mode={"ACTIVITY_MODAL"} interviewId={id} />
          </div>
        </div>
      </div>
    </>
  );
};
export default Preview;
